export const decodeBase64 = (encoded: string): string => {
  try {
    return atob(encoded)
  } catch (error) {
    console.error('Error decoding base64:', error)
    return encoded
  }
}
